import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { validateToken } from "../tokenValidation";
import secureStorage from "../utils/secureStorage";
const ViewCustomerRecords = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const aadhaarResponse =
        location.state?.aadhaarResponse ||
        JSON.parse(secureStorage.get("user")) ||
        {};

    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [documentmodalOpen, setDocumentmodalOpen] = useState(false);
    const [documentContent, setDocumentContent] = useState(null);
    const [documentType, setDocumentType] = useState(null);
    const [documentType1, setDocumentType1] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const API_URL = process.env.REACT_APP_API_URL;

    const fetchCustomerRecords = async (abhaNumber, token) => {
        setLoading(true);
        try {
            if (!token) {
                console.error("Authentication token not found. Please log in again.");
                return;
            }

            const response = await fetch(
                `${API_URL}abdm-data-share/get-documents?patientId=${abhaNumber}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        "X-HIP-ID": secureStorage.get("clinic"),
                    },
                }
            );

            if (response.ok) {
                const result = await response.json();
                setRecords(result.data || []);
            } else {
                console.error("Failed to fetch records:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching records:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        validateToken(navigate);
    }, [navigate]);

    useEffect(() => {
        const { abhaNumber, token } = aadhaarResponse;
        if (abhaNumber && token) {
            fetchCustomerRecords(abhaNumber, token);
        }
    }, []);


    const fetchDocumentContent = async (documentNumber) => {
        if(documentNumber){
            setLoading(true);
            try {
                const token = secureStorage.get("authToken");
                if (!token) {
                    console.error("Authentication token not found. Please log in again.");
                    return;
                }
    
                const response = await fetch(
                    `${API_URL}abdm-data-share/get-document?documentNumber=${documentNumber}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                            "X-HIP-ID": secureStorage.get("clinic"),
                        },
                    }
                );
    
                if (response.ok) {
                    const result = await response.json();
                    const base64Data = result.data || null;
    
                    if (base64Data) {
                        const contentType = detectContentType(base64Data);
                        setDocumentContent(base64Data);
                        setDocumentType(contentType);
                        setModalOpen(true);
                    } else {
                        console.error("No data available for the document.");
                    }
                } else {
                    console.error("Failed to fetch document:", response.statusText);
                }
            } catch (error) {
                console.error("Error fetching document:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    const detectContentType = (base64) => {
        if (base64.startsWith("JVBER")) {
            return "application/pdf";
        }
        if (base64.startsWith("/9j/")) {
            return "image/jpeg";
        }
        if (base64.startsWith("iVBOR")) {
            return "image/png";
        }
        return "unknown";
    };

    const closeModal = () => {
        setModalOpen(false);
        setDocumentContent(null);
        setDocumentType(null);
    };
    const closeModal1 = () => {
        setDocumentmodalOpen(false);
        setDocumentType("");
        setSelectedFile(null);
    };

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const handleUploadClick = () => {
        setDocumentmodalOpen(true);
    };


    const documentTypeMapping = {
        "Prescription": "Prescription",
        "Diagnostic Report": "DiagnosticReport",
        "OP Consultation": "OPConsultation",
        "Discharge Summary": "DischargeSummary",
        "Immunization Record": "ImmunizationRecord",
        "Health Document Record": "HealthDocumentRecord",
        "Wellness Record": "WellnessRecord",
        "Invoice": "Invoice",
      };
    

    const handleUpload = async () => {
        if (!documentType1 || !selectedFile) {
            alert("Please select a document type and a file.");
            return;
        }
        const apiDocumentType = documentTypeMapping[documentType1];
        const formData = new FormData();
        formData.append("file", selectedFile);

        try {
            const token = secureStorage.get("authToken");
            if (!token) {
                console.error("Authentication token not found. Please log in again.");
                return;
            }

            const abhaNumber = aadhaarResponse?.abhaNumber;
            if (!abhaNumber) {
                alert("ABHA Number not found.");
                return;
            }

            const response = await fetch(
                `${API_URL}abdm-data-share/upload?abhaNumber=${abhaNumber}&documentType=${apiDocumentType}`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "X-HIP-ID": secureStorage.get("clinic"),
                    },
                    body: formData,
                }
            );

            if (response.ok) {
                toast.success("Document uploaded successfully!");
                setDocumentmodalOpen(false);
                setDocumentType1("");
                setSelectedFile(null);
                fetchCustomerRecords(abhaNumber, token);
            } else {
                console.error("Failed to upload document:", response.statusText);
                alert("Failed to upload document.");
            }
        } catch (error) {
            console.error("Error uploading document:", error);
            alert("Error uploading document.");
        }
    };



    return (
        <div className="min-h-screen bg-gray-100 py-8 px-6">
            <div className="flex items-center justify-between mb-6">
                <h1 className="text-2xl font-bold text-teal-600">
                    Customer Document Records
                </h1>
                <button
                    className="bg-teal-600 text-white px-4 py-2 rounded-md hover:bg-teal-600"
                    onClick={() => handleUploadClick()}
                >
                    Upload New Document
                </button>
            </div>
            {loading ? (
                <p className="text-center text-blue-600">Loading...</p>
            ) : records.length > 0 ? (
                <table className="w-full bg-white shadow-lg rounded-lg overflow-hidden">
                    <thead>
                        <tr className="bg-gradient-to-r from-teal-500 to-blue-700 text-white">
                            <th className="py-3 px-4 text-left">SL No</th>
                            <th className="py-3 px-4 text-left">Document Name</th>
                            <th className="py-3 px-4 text-left">Document Type</th>
                            <th className="py-3 px-4 text-left">Generated Date</th>
                            <th className="py-3 px-4 text-left">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {records.map((doc, index) => (
                            <tr key={doc.id || index} className="border-b hover:bg-blue-50">
                                <td className="py-3 px-4">{index + 1}</td>
                                <td className="py-3 px-4">{doc.documentName}</td>
                                <td className="py-3 px-4">{doc.documentType}</td>
                                <td className="px-4 py-3 text-sm font-medium text-gray-700">
                                    {new Date(doc.generatedDate).toLocaleDateString()}
                                </td>
                                <td
                                    className="px-4 py-3 text-[#2B98D6] font-medium hover:underline cursor-pointer"
                                    onClick={() => fetchDocumentContent(doc.documentNumber)}
                                >
                                    View
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p className="text-center text-gray-500">No records found.</p>
            )}

            {modalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-w-4xl">
                        <h2 className="text-2xl font-bold mb-4">Document Viewer</h2>
                        {documentContent ? (
                            <div>
                                {documentType === "application/pdf" ? (
                                    <iframe
                                        src={`data:application/pdf;base64,${documentContent}`}
                                        className="w-full h-96"
                                        title="PDF Viewer"
                                    ></iframe>
                                ) : documentType.startsWith("image/") ? (
                                    <img
                                        src={`data:${documentType};base64,${documentContent}`}
                                        alt="Document"
                                        className="w-full h-[552px]"
                                    />
                                ) : (
                                    <p>Unsupported file type.</p>
                                )}
                            </div>
                        ) : (
                            <p>No content available for this document.</p>
                        )}
                        <button
                            className="mt-4 bg-teal-500 text-white px-4 py-2 rounded-md hover:bg-teal-600"
                            onClick={closeModal}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}

            {documentmodalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-w-4xl">
                        <h2 className="text-2xl font-bold mb-4">Upload Document</h2>
                        <div className="mb-4">
                            <label className="block text-gray-700 font-bold mb-2">
                                Document Type
                            </label>
                            <select
                                value={documentType}
                                onChange={(e) => setDocumentType1(e.target.value)}
                                className="w-full border border-gray-300 p-2 rounded-md"
                            >
                                <option value="">Select Document Type</option>
                                <option value="Prescription">Prescription</option>
                                <option value="Diagnostic Report">Diagnostic Report</option>
                                <option value="OP Consultation">OP Consultation</option>
                                <option value="Discharge Summary">Discharge Summary</option>
                                <option value="Immunization Record">Immunization Record</option>
                                <option value="Health Document Record">Health Document Record</option>
                                <option value="Wellness Record">Wellness Record</option>
                                <option value="Invoice">Invoice</option>
                            </select>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 font-bold mb-2">
                                Upload File
                            </label>
                            <input
                                type="file"
                                onChange={handleFileChange}
                                className="w-full border border-gray-300 p-2 rounded-md"
                            />
                        </div>
                        <div className="flex justify-end">
                            <button
                                className="bg-teal-500 text-white px-4 py-2 rounded-md hover:bg-teal-600 mr-2"
                                onClick={handleUpload}
                            >
                                Upload
                            </button>
                            <button
                                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400"
                                onClick={closeModal1}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer />
        </div>

    );
};

export default ViewCustomerRecords;
